

export const STATUS = [
  {
    id: 1,
    name: "有効"
  },
  {
    id: 0,
    name: "無効"
  },

]

export const FILTER_STATUS = [
  {
    id: 'all',
    name: "全て"
  },

  {
    id: 1,
    name: "有効"
  },
  {
    id: 0,
    name: "無効"
  },
]

export const STATUS_ACTIVE = [
  {
    id: 1,
    name: "稼働中"
  },
  {
    id: 0,
    name: "停止中"
  },
]

export const GATEWAY_CONSTANT = {
  "STATUS" : STATUS,
  "FILTER_STATUS" : FILTER_STATUS,
  "STATUS_ACTIVE" : STATUS_ACTIVE
}
